
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

var TravelExpensePage = Vue.extend({})
Vue.component('travelExpense-page', TravelExpensePage)

export default {
name: 'TravelExpensePage',
directives: {
TransferDom
},
components: {
XTable,XButton,XInput,InlineXSwitch,XTextarea,XDialog,Group,Selector,CellBox
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '08c4a7eccfdb4efa9ba2c8c12e8f81fa',//差旅报销
operatorId: '',//当前 操作人
refModule: '',
refRecordId: '',
stepId: '',
info: {},
togetherName: '',//同行人
tripRemark: '',//出差事由
name: '',//费用名称
isDeduction: false,//是否用于抵扣费用报销(不计入成本)
isDeductionVal: 0,//是否用于抵扣费用报销(不计入成本)
remark: '',//备注
fileObj: {},//上传附件集合
fileShowList: [],//上传附件集合-预览
uploadedFileIdList: [],//已上传附件ID集合
oldRefRecordIds: '',//对应文件记录，明细ID字符串

showToast: false,//弹窗-dialog


tripShow: false,
tripName: '',//dialog-出差审批表名称
tripNameSearch: '',//dialog-出差审批表名称-供搜索
addressList: [],//dialog-出差地点
address: '',//dialog-出差地点-val
addressSearch: '',//dialog-出差地点-供搜索

preStatus: true,
nextStatus: false,

tripList: [],//dialog-业务搜索结果
tripNameList: [],//dialog-业务搜索结果
tripAllNum: '',//dialog-业务总个数
tripChoosed: {},//dialog-选择的业务
pageNum: 1,//dialog-业务搜索结果-页码
switchValue: false,//dialog-选择业务switch



treeType: '',//0出差人，1责任中心，2收款人/单位
checkTreeShow: false,
treeData: [],//人员结构树
checkTreeSearchVal: '',//人员结构树搜索内容
checkTreeSearchResult: [],//人员结构树搜索结果
treeProps: {
children: 'children',
label: 'name'
},
checkDeptResult: {},//人员结构树-选择结果


centerDepartmentName: '',


businessShow: false,
businessName: '',//dialog-业务名称
selectorList: [],//dialog-业务类型
selectorValue: '',//dialog-业务类型-val

businessPreStatus: true,
businessNextStatus: false,

businessList: [],//dialog-业务搜索结果
businessNameList: [],//dialog-业务搜索结果
businessAllNum: '',//dialog-业务总个数
businessChoosed: {},//dialog-选择的业务
businessPageNum: 1,//dialog-业务搜索结果-页码
businessSwitchValue: false,//dialog-选择业务switch



expenseShow: false,
feeRemark: '',//费用类型及说明
isEInvoice: false,//是否电子发票
isEInvoiceVal: 0,//是否电子发票
eleInvoiceNo: '',//发票号码
startDate: '',
endDate: '',
startPlace: '',
endPlace: '',
money1: '',
money2: '',
outDays: '',
money3: '',
tripDays: '',
money4: '',
money5: '',
money6: '',
moneyRemark: '',

savedList: {},//成功保存后，返回的明细list
savedObj: {},//成功保存后，返回的明细Obj
total1: '',//费用合计
total2: '',//费用合计大写
shouldPay: '',

btnText: '增加',


bankAccount: '',
bank: '',
payUnitName: '',//收款人\单位
willTrivalMoney: '',//预借差旅费

}
},
mounted () {
this.axios({
url: this.baseUrl+'/wechat/expense/modExpense?flowId='+this.flowId+'&type=1',
method: 'get'
}).then((response) => {
this.info = response.data.obj;
this.tripName = this.info.outPeopleName;
this.payUnitName = this.info.payUnitName;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
this.operatorId = response.data.operatorId;
}).catch((response) => {
this.$vux.loading.hide();
});
this.$emit('sendTitleToParent','报销申请-差旅报销');
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
});
setTimeout(() => {
this.$vux.alert.hide();
}, 2000)
},
openDialog (v) {// 打开选择业务-dialog
this.tripShow = false;
this.checkTreeShow = false;
this.businessShow = false;
this.expenseShow = false;
this.showToast = true;
if(v == 'trip'){//出差审批
this.tripShow = true;
this.searchTrip();
}else if(v == 'tripName' || v == 'center'){//出差人
this.checkTreeShow = true;
this.getDeptTree(v);
}else if(v == 'business'){//借款抵消
this.businessShow = true;
this.getBusinessList();
this.searchBusiness();
}else if(v == 'expense'){//费用明细
this.expenseShow = true;
}else if(v == 'payUnitName'){//收款人/单位
this.checkTreeShow = true;
this.getDeptTree(v);
}

},
switchVal (data) {//switch
if(data){
this.isDeductionVal = 1;
}else{
this.isDeductionVal = 0;
}
},
chooseFile () {// 选择附件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
});
this.submitFile();
},
deleteFile (index) {// 删除已选附件
this.fileShowList.splice(index,1);

let deleteFileId = this.uploadedFileIdList[index];
let fileData = new FormData();
fileData.append("fileId",deleteFileId);

this.axios({
url: this.baseUrl+'/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
console.log('费用报销deleteFile',response);
this.uploadedFileIdList.splice(index,1);
}).catch((response) => {
this.$vux.loading.hide();
});

},
async submitFile () {// 上传附件-图片
let fileObjL = this.fileObj.length;
for(let i=0;i<fileObjL;i++){
let fileData = new FormData();
fileData.append("file",this.fileObj[i]);
fileData.append("taskId",this.info.id);
fileData.append("refRecordId",this.savedList.id);
fileData.append("refModule",this.refModule);
fileData.append("stepId",this.stepId);
fileData.append("operatorId",this.operatorId);
fileData.append("expenseType",this.info.type);
fileData.append("flowId",this.flowId);

let res = await this.axios({
url: this.baseUrl+'/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
});
this.uploadedFileIdList.push(res.data.fileId);

let that = this;
let file = this.fileObj[i];
let reader = new FileReader();
reader.readAsDataURL(file);
reader.onload=function(e) {
that.fileShowList.push(this.result);
}
}

this.$vux.loading.hide();
},

async searchTrip () {// dialog-搜索业务
this.tripList = [];
let res = await this.axios({
url: this.baseUrl+'/wechat/businessTrip/findTripList?status=2&isChoose=1&page='+this.pageNum+'&rows=15&outPeoplesName='+this.tripNameSearch+'&address='+this.addressSearch,
method: 'get'
});
console.log('searchTrip',res.data);
this.$vux.loading.hide();
this.tripList = res.data.list;
let tripLength = res.data.list.length;
for(let i=0;i<tripLength;i++){
this.tripNameList.push(res.data.list[i].tripName);
}
this.tripAllNum = Math.ceil(res.data.total/15);
},
getPrePage () {//dialog-上一页
if(this.pageNum == 1){
this.preStatus = true;
}else{
this.tripChoosed = {};
this.nextStatus = false;
this.pageNum--;
this.searchTrip();
}
},
getNextPage () {//dialog-下一页
if(this.pageNum == this.tripAllNum){
this.nextStatus = true;
}else{
this.tripChoosed = {};
this.preStatus = false;
this.pageNum++;
this.searchTrip();
}
},
chooseTrip () {//dialog-确定
this.showToast = false;
this.tripName = this.tripChoosed.outPeoplesName;
this.tripRemark = this.tripChoosed.out_reason;

if(this.tripChoosed.id){
this.willTrivalMoney = this.tripChoosed.planMoney;
}

},
clearName (v) {// 清除业务
if(v == 'trip'){
this.tripChoosed = {};
this.tripName = '';
this.tripRemark = '';
}else if(v == 'center'){
this.centerDepartmentName = '';
}else if(v == 'business'){
this.businessName = '';
}

},


getDeptTree (v) {//获取人员架构
let link;
if(v == 'tripName'){
link = '/wechat/staff/getOrgStaff';
this.treeType = 0;
}else if(v == 'center'){
link = '/wechat/commonInterface/deptTree';
this.treeType = 1;
}else if(v == 'payUnitName'){
link = '/wechat/staff/getOrgStaff';
this.treeType = 2;
}
this.axios({
url: this.baseUrl+link,
method: 'get'
}).then((response) => {
this.treeData = response.data;
this.checkTreeShow = true;
}).catch((response) => {
this.$vux.loading.hide();
});
},
clearSearchResult () {//清空搜索栏
this.checkTreeSearchResult = [];
},
clearDeptResult () {//清除组织架构
this.employeeName = '';
this.checkDeptResult = {};
},
getArray (data,name) {//组织架构搜索-递归
for (var i in data) {
if (data[i].name == name || data[i].name.indexOf(name) != -1) {
this.checkTreeSearchResult.push(data[i]);
}else {
this.getArray(data[i].children, name);
}
}
},
addToTree (item) {//将搜索结果添加到树
let CheckedNodes = this.$refs.tree.getCheckedNodes();
CheckedNodes.push(item);
this.$refs.tree.setCheckedNodes(CheckedNodes);
this.checkTreeSearchResult = [];
},
getCheckedNodes() {//选择-人员架构树

let checkedPersonArr = this.$refs.tree.getCheckedNodes();

this.checkDeptResult = checkedPersonArr[0];
if(this.treeType == 0){
this.tripName = this.checkDeptResult.name;
}else if(this.treeType == 1){
this.centerDepartmentName = this.checkDeptResult.name;
}else if(this.treeType == 2){
this.payUnitName = this.checkDeptResult.name;
}
this.checkTreeShow = false;
this.showToast = false;
console.log('组织架构树',this.checkDeptResult,this.belongLeader);
},
treeSearch () {//提交-组织架构搜索按钮
this.checkTreeSearchResult = [];
let checkTreeSearchVal = this.checkTreeSearchVal;
let treeData = this.treeData;
if(checkTreeSearchVal!=''){
this.getArray(treeData,checkTreeSearchVal);
}
},



async getBusinessList () {
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listRefFlowTypes',
method: 'get'
});
this.selectorList = res.data.list;
},
async searchBusiness () {// dialog-搜索业务
this.businessList = [];
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/businessList?businessName='+this.businessName+'&flowType='+this.selectorValue+'&page='+this.pageNum+'&rows=15',
method: 'get'
});
console.log(res)
this.$vux.loading.hide();
this.businessList = res.data.list;
let businessLength = res.data.list.length;
for(let i=0;i<businessLength;i++){
this.businessNameList.push(res.data.list[i].businessName);
}
this.businessAllNum = Math.ceil(res.data.total/15);
},
getBusinessPrePage () {//dialog-上一页
if(this.pageNum == 1){
this.preStatus = true;
}else{
this.businessChoosed = {};
this.nextStatus = false;
this.pageNum--;
this.searchBusiness();
}
},
getBusinessNextPage () {//dialog-下一页
if(this.pageNum == this.businessAllNum){
this.nextStatus = true;
}else{
this.businessChoosed = {};
this.preStatus = false;
this.pageNum++;
this.searchBusiness();
}
},
chooseBusiness () {//dialog-确定
this.showToast = false;
this.businessName = this.businessChoosed.businessName;
},
clearBusiness () {// 清除业务
this.businessChoosed = {};
this.businessName = '';
},



switchEInvoice (data) {//switch
if(data){
this.isEInvoiceVal = 1;
}else{
this.isEInvoiceVal = 0;
}
},
chooseStartDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.startDate,
onConfirm (val) {
that.startDate = val
}
})
},
chooseEndDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.endDate,
onConfirm (val) {
that.endDate = val
}
})
},
expenseSave(){//报销明细-保存
this.$vux.loading.show({
text: '保存中'
});
let formData = new FormData();
if(this.btnText == '修改'){
formData.append("id",this.savedList.id);
}
formData.append("businessId",this.info.id);
formData.append("type",'1');
formData.append("feeRemark",this.feeRemark);
formData.append("isEInvoice",this.isEInvoiceVal);
formData.append("eleInvoiceNo",this.eleInvoiceNo);
formData.append("startDate",this.startDate);
formData.append("endDate",this.endDate);
formData.append("startPlace",this.startPlace);
formData.append("endPlace",this.endPlace);
formData.append("money1",this.money1);
formData.append("money2",this.money2);
formData.append("outDays",this.outDays);
formData.append("money3",this.money3);
formData.append("tripDays",this.tripDays);
formData.append("money4",this.money4);
formData.append("money5",this.money5);
formData.append("money6",this.money6);
formData.append("remark",this.moneyRemark);

this.axios({
url: this.baseUrl+'/wechat/expense/saveMoney',
method: 'post',
headers: {
'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
},
data: formData
}).then((response) => {
this.$vux.loading.hide();
console.log('dialog-报销明细-保存',response.data);
if(response.data.status == 1){//保存成功
if(response.data.list.length>0){
this.savedList = response.data.list[0];
}
this.total1 = response.data.obj.total1;
this.total2 = response.data.obj.total2;
this.shouldPay = response.data.obj.shouldPay;
this.savedObj = response.data.obj;
this.btnText = '修改';
}else{
this.showMsg(response.data.error);
}

this.showToast = false;
this.$common.showToastMsg(response.data.success);
}).catch((response) => {
this.$vux.loading.hide();
});
},
expenseDelete (){//报销明细-删除
this.$vux.loading.show({
text: '正在删除'
});
let formData = new FormData();
formData.append("id",this.savedList.id);
formData.append("businessId",this.info.id);

this.axios({
url: this.baseUrl+'/wechat/expense/delMoney',
method: 'post',
data: formData
}).then((response) => {
this.$vux.loading.hide();
console.log('dialog-报销明细-删除',response.data);
if(response.data.status == 1){//删除成功
this.btnText = '增加';
this.savedList = {};
this.total1 = '';
this.total2 = '';
this.shouldPay = '';
}
this.showToast = false;
}).catch((response) => {
this.$vux.loading.hide();
});
},


saveForm () {//保存
if(this.name == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});
let formData = new FormData();
formData.append("id",this.info.id);
formData.append("flowId",this.info.flowId);
formData.append("staffId",this.info.staffId);
formData.append("recCode",this.info.recCode);
formData.append("name",this.name);
formData.append("togetherName",this.togetherName);
formData.append("tripRemark",this.tripRemark);
formData.append("isDeduction",this.isDeductionVal);
formData.append("remark",this.remark);
formData.append("type",this.info.type);
formData.append("centerDepartmentName",this.centerDepartmentName);

if(this.businessChoosed.id){
formData.append("businessReport",this.businessChoosed.reportNo);
formData.append("flowType",this.businessChoosed.flowType);
formData.append("businessId",this.businessChoosed.id);
formData.append("businessName",this.businessChoosed.businessName);
}

formData.append("userDepartId",this.info.userDepartId);
formData.append("applyDate",this.info.applyDate);
formData.append("jibie",this.info.jibie);
formData.append("userDepartName",this.info.userDepartName);
formData.append("payUnitName",this.payUnitName);
formData.append("bank",this.bank);
formData.append("bankAccount",this.bankAccount);
formData.append("total1",this.total1);
formData.append("total2",this.total2);
formData.append("willTrivalMoney",this.willTrivalMoney);
formData.append("shouldPay",this.total1-this.willTrivalMoney);

formData.append("payStatus",this.info.payStatus);

formData.append("payDate",this.info.payDate);
formData.append("remark",this.remark);

if(this.tripChoosed.id){
formData.append("businessTripId",this.tripChoosed.id);
formData.append("businessTripName",this.tripChoosed.out_reason+'--出差申请');
formData.append("tripDepartment",this.tripChoosed.departmentName);
formData.append("tripDetails",this.tripChoosed.start_time+'至'+this.tripChoosed.end_time+'共'+this.tripChoosed.out_days+'天'+this.tripChoosed.out_honr+'小时');
}

this.axios({
url: this.baseUrl+'/wechat/expense/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData
}).then((response) => {
console.log('saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}

}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
startData.append("staffId",this.info.staffId);
this.axios({
url: this.baseUrl+'/wechat/expense/startFlow',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: startData
}).then((response) => {
console.log('startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});


},
}
}



// WEBPACK FOOTER //
// ./src/components/launch/finance/travelExpense.vue